module.exports = __webpack_public_path__ + "img/ki.1e425fd.svg";